export default __webpack_public_path__ + "static/media/022-sunset.ecaf04cc.svg";